import { z } from "zod";

export const checkoutSchema = z.object({
  firstName: z.string().min(2, "First name is required"),
  lastName: z.string().min(2, "Last name is required"),
  email: z.string().email("Invalid email address"),
  suite: z.string().optional(),
  phone: z.string().min(9, "Phone number is required").max(15, "Phone number is too long"),
  street: z.string().min(5, "Street is required"),
  country: z.string().min(2, "Country is required"),
  city: z.string().min(2, "City is required"),
  state: z.string().min(2, "State is required"),
  zipCode: z.string().min(5, "ZIP code is required"),
  paymentMethod: z.enum(["card", "paypal", "cash"]),
  stripePaymentMethodId: z.string().optional(),
  paymentIntentId: z.string().optional(), 
  customerId: z.string().optional(),
  existingShippingAddress: z.string().optional(),
});